import {
  ALL_SESSION_VLANS_VALUE,
  getTrunkedNetworkUidsFromNic,
} from '../../../../../../Configure/Utils';

export type NetworkOrVlansCellDisplay =
  | { kind: 'text'; text: string }
  | { kind: 'viewAll'; count: number };

export function getNetworkOrVlansCellDisplay(
  nic: {
    trunk?: TrunkedNetworkInterface;
    network?: { name?: string; uid?: string };
  },
  allSessionVlansLabel: string,
): NetworkOrVlansCellDisplay {
  if (!nic.trunk?.enabled) {
    return { kind: 'text', text: nic.network?.name ?? '' };
  }

  if (nic.trunk.networks == null) {
    return { kind: 'text', text: allSessionVlansLabel };
  }

  const trunkedNetworks = nic.trunk.networks;

  if (trunkedNetworks.length <= 1) {
    return {
      kind: 'text',
      text: trunkedNetworks[0]?.name ?? nic.network?.name ?? '',
    };
  }

  const selection = getTrunkedNetworkUidsFromNic(nic);

  if (selection.includes(ALL_SESSION_VLANS_VALUE)) {
    return { kind: 'text', text: allSessionVlansLabel };
  }

  if (selection.length > 1) {
    return { count: selection.length, kind: 'viewAll' };
  }

  return {
    kind: 'text',
    text: nic.network?.name ?? trunkedNetworks[0]?.name ?? '',
  };
}
